import { MutationTree } from 'vuex';

export const mutations = {
    setAllowSpeech(state) {
        state.allowSpeech = true;
    },
    userLoaded(state, data) {
        state.error = false;
        state.user = data;
    },
    userError(state) {
        state.error = true;
        state.user = undefined;
    },
    dialogGroupLoaded(state, data) {
        state.error = false;
        state.avaAnimations = data.animations;
    },
    groupSelected(state, data) {
        state.selectedDialogGroup = data;
    },
    setAudio(state, data) {
        state.currentAudio = data;
    },
    setConversationData(state, data) {
        state.conversationId = data.conversationId;
        state.avaToken = data.token;
    },
    setActivityId(state, id) {
        state.activityId = id;
    },
    setWaterMark(state, watermark) {
        state.watermark = watermark;
    },
    setAudioSrc(state, audio) {
        state.audioSrc = audio;
    },
    setIdleGroup(state, groupType) {
        state.idleGroup = groupType;
    },
    setIsReady(state, val) {
        state.isReady = val;
    },
    updateAskAvaQuestion(state, question) {
        state.askAvaQuestion = question
    }
};